import { trackCTAClick } from '@/lib/analytics';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: prefersReduced ? 'instant' : 'smooth', block: 'start' });
};

import { useTranslation } from 'react-i18next';

export const BioAgeTeaser = () => {
  const { t } = useTranslation();
  return (
    <section
      data-testid="bioage-teaser-section"
      className="py-16 lg:py-24 px-6 sm:px-8"
      style={{ backgroundColor: 'var(--vc-bg)' }}
    >
      <div className="max-w-[1160px] mx-auto text-center">
        <h2
          className="font-bold tracking-tight text-2xl sm:text-3xl lg:text-[34px]"
          style={{ fontFamily: 'Inter, sans-serif', color: 'var(--vc-fg)' }}
        >
          {t('bioage.title')}
        </h2>
        <p
          className="mt-4 text-base sm:text-[17px] leading-relaxed max-w-xl mx-auto"
          style={{ color: 'var(--vc-fg-muted)', fontFamily: 'Inter, sans-serif' }}
        >
          {t('bioage.body')}
        </p>

        <button
          data-testid="bioage-secondary-cta-button"
          onClick={() => {
            trackCTAClick('bioage_secondary');
            scrollToSection('waitlist');
          }}
          className="mt-8 inline-flex items-center justify-center h-12 px-8 text-sm font-medium rounded-xl border transition-colors duration-200 active:scale-[0.98]"
          style={{
            color: 'var(--vc-gold)',
            borderColor: 'var(--vc-gold)',
            backgroundColor: 'transparent',
            fontFamily: 'Inter, sans-serif',
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(214,168,74,0.12)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        >
          {t('bioage.cta')}
        </button>
      </div>
    </section>
  );
};
